import { render, staticRenderFns } from "./Eleicoes.vue?vue&type=template&id=a3a888d2"
import script from "./Eleicoes.vue?vue&type=script&lang=js"
export * from "./Eleicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports